import { Component, computed, inject, input } from '@angular/core';
import {IItem} from '../../../../../types/IItem';
import { ResultsTableRowAvailabilityBadgeComponent } from './results-table-row-availability-badge/results-table-row-availability-badge.component';
import {IconsComponent} from '../../../../../shared/components/icons/icons.component';
import {LinkComponent} from '../../../../../shared/components/link/link.component';
import {ResultsTableRowPriceComponent} from './results-table-row-price/results-table-row-price.component';
import {ResultsTableRowImageComponent} from './results-table-row-image/results-table-row-image.component';
import {ResultsTableRowActions} from './results-table-row-actions/results-table-row-actions';
import {ResultsStore} from '../../../../../shared/store/results.store';
import {EventService} from '../../../../../shared/services/event.service';
import {ResultTableService} from '../../../services/result-table.service';
import {PostHogService} from '../../../../../shared/services/posthog.service';
import {AccessService} from '../../../../../shared/services/access.service';

@Component({
  selector: 'app-results-table-row',
  standalone: true,
  imports: [ResultsTableRowAvailabilityBadgeComponent, IconsComponent, LinkComponent, ResultsTableRowPriceComponent, ResultsTableRowImageComponent, ResultsTableRowActions],
  templateUrl: './results-table-row.component.html',
  styleUrl: './results-table-row.component.css'
})
export class ResultsTableRowComponent {
  item = input.required<IItem>();

  resultsStore = inject(ResultsStore);
  resultTableService = inject(ResultTableService);
  access = inject(AccessService);
  private eventService = inject(EventService);
  private posthogService = inject(PostHogService);

  readonly isSpecial = computed(() => this.resultsStore.getPricing()(this.item().id, this.item().cost)?.price > this.resultsStore.getPricing()(this.item().id, this.item().cost)?.price_special);

  mileageWarranty = computed(() => {
    if (!this.item().features.mileage_warranty) return '';
    return this.item().features.mileage_warranty?.toString().substring(0, 2) + 'K mi';
  });

  featureString = computed(() => `${this.item()?.features?.load_index ?? ''} ${this.item()?.features?.speed_rating ?? ''} ${this.item()?.features?.load_range ?? ''}`);

  readonly editItemVisible = computed(() => this.access.has('edit_item'));
  readonly editItemDisabled = computed(() => this.access.cannot('edit_item'));

  readonly itemHistoryVisible = computed(() => this.access.has('view_item_history'));
  readonly itemHistoryDisabled = computed(() => this.access.cannot('view_item_history'));

  editItem() {
    const item = this.item();
    this.posthogService.posthog.capture('tire_item_edited', {
      tire_brand: item.brand,
      tire_model: item.model,
      tire_id: item.id,
    });
    this.eventService.emit('edit-item', {item});
  }

  showItemHistory() {
    this.eventService.emit('open-item-history', {item: this.item()});
  }
}
